import {USER_LOGIN_TYPES} from '../constants/userLogin.types'
import {UserLogin, UserLoginAction, UserLoginState} from '../interfaces/userLogin.interface'

const initialState: UserLoginState = {
  datos: {},
  logo: "",
  width: 1000,
  height: 1000,
  limite: 0,
  session: {},
  propina: {},
  config: {tickethabilitado: false, comprobantesMedidas: []}
}

const userLoginReducer = (
  state: UserLogin = initialState,
  action: UserLoginAction
): UserLoginState => {
  switch (action.type) {
    case USER_LOGIN_TYPES.SAVE_USER_LOGIN:
      return {...state, datos: action.payload, limite: 0}
    case USER_LOGIN_TYPES.SAVE_EMPRESA_LOGO:
      return {...state, logo: action.payload}
    case USER_LOGIN_TYPES.CHANGE_DIMENSIONS:
      return {...state, ...action.payload}
    case USER_LOGIN_TYPES.UPDATE_DATA_USER:
      return {...state, datos: action.payload}
    case USER_LOGIN_TYPES.UPDATE_DATA_USER:
      return {...state, datos: action.payload}
    case USER_LOGIN_TYPES.UPDATE_DATA_CONFIG:
      return {...state, config: action.payload}
    case USER_LOGIN_TYPES.SAVE_LIMITE:
      return {...state, limite: action.payload}
    case USER_LOGIN_TYPES.SAVE_SESSION_DATA:
      let newStateUser = {...state.session}
      if(action.component){
        newStateUser[action.component] = action.payload
        return {...state, session: newStateUser}
      } else
        return {...state, session: action.payload}
      case USER_LOGIN_TYPES.SAVE_PROPINA_DATA:
        return {...state, propina: action.payload}
    default:
      return state
  }
}

export default userLoginReducer
